import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Link } from "react-router-dom";
import "../../styles/CarouselStyles.css";

const Carousel = () => {
  useEffect(() => {
    const bootstrap = require("bootstrap");
    const carouselElement = document.getElementById("mainCarousel");
    new bootstrap.Carousel(carouselElement);
  }, []);

  return (
    <div
      id="mainCarousel"
      className="carousel slide main-carousel"
      data-bs-ride="carousel"
    >
      {/* Indicadores */}
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#mainCarousel"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#mainCarousel"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#mainCarousel"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>

      {/* Slides */}
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src="/images/slides/Slide1.jpg"
            className="d-block w-100"
            alt="Slide 1"
          />
          <div className="container">
            <div className="carousel-caption text-start">
              <p className="subtitle">ARQUITECTURA || INTERIOR</p>
              <h1 className="carousel-title">SOMOS ARQUITECTOS EXPERTOS</h1>
              <p>
                <Link to="/projects" className="btn btn-outline-primary btn-carousel">
                  PROYECTOS
                </Link>
              </p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="/images/slides/Slide2.jpg"
            className="d-block w-100"
            alt="Slide 2"
          />
          <div className="container">
            <div className="carousel-caption text-center">
              <p className="subtitle">Diseños innovadores, alta calidad.</p>
              <h1 className="carousel-title">CALIDAD E INNOVACIÓN</h1>
              <p>
                <Link to="/about" className="btn btn-outline-primary btn-carousel">
                  CONÓCENOS
                </Link>
              </p>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="/images/slides/Slide3.jpg"
            className="d-block w-100"
            alt="Slide 3"
          />
          <div className="container">
            <div className="carousel-caption text-end">
              <p className="subtitle">Creando espacios sostenibles para las generaciones futuras.</p>
              <h1 className="carousel-title">COMPROMETIDOS CON EL FUTURO</h1>
              <p>
                <Link to="/contact" className="btn btn-outline-primary btn-carousel">
                  CONTÁCTANOS
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Controles del Carrusel */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#mainCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#mainCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
